module.exports = __webpack_public_path__ + "img/1590298565.a1a1d26b.jpg";